import api from './api';

// Watchlist read access for the strategy builder.
//
// These call the MAIN backend (:3002), which OWNS the watchlist data
// (wishlist_control_table / content_wishlist in victory_db). Both
// endpoints are SELF-SCOPED: the backend derives the user from the
// auth cookie (same JWT the strategy engine uses), so the client
// never sends a user_id. That removes the IDOR surface and guarantees
// the watchlist owner == the id a strategy is saved under.
//
// Contract (mirrors the existing /wishlistcontrol envelope so the
// backend can reuse the same shape):
//   GET /me/watchlists            -> { data: [{ wishlist_id, wishlist_name }] }
//   GET /me/watchlists/:id/stocks -> { data: [{ script_id, token }] }
export const watchlistService = {
  getMyWatchlists: () => api.get('/me/watchlists'),
  getWatchlistStocks: (wishlistId) => api.get(`/me/watchlists/${wishlistId}/stocks`),
};

export default watchlistService;
